var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"base-scroll-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c(_vm.direction === 'left' ? 'icon-arrow-left' : 'icon-arrow-right',{tag:"component",staticClass:"icon",attrs:{"width":"16","height":"16"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }